//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  signal,
  WritableSignal,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

//local imports
import { CatalogConstants, RoomContentModel, RoomModel } from "@app/catalog";
import { BreadcrumbChangedMessage, BreadcrumbItemToggleMessage, Messenger, PresenterType } from "@app/shared";

@PresenterType({
  model: RoomContentModel,
  key: "tileBottom",
})

@Component({
  selector: 'room-content-carousel-item-bottom',
  standalone: false,
  templateUrl: './room-content-carousel-item-bottom.component.html',
  styleUrl: './room-content-carousel-item-bottom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoomContentCarouselItemBottomComponent implements OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private selectedRoomContents = [];
  private selectedRooms = [];
  private searchItems = [];

  public data: WritableSignal<RoomContentModel> = signal<RoomContentModel>(undefined);

  constructor(
    private messenger: Messenger
  ){
    this.messenger.subscribe(this, BreadcrumbChangedMessage, (message) => {
        if(message.breadcrumbName !== CatalogConstants.CATALOG) { 
            return;
        }
        message.breadcrumbs.forEach((item) => {

          if(item instanceof RoomContentModel) {
            const exists = this.selectedRoomContents.some(room => room.id === item.id);
            if (!exists) {
              this.selectedRoomContents.push(item);
            }
          } else if(item instanceof RoomModel) {
            const exists = this.selectedRooms.some(room => room.id === item.id);
            if (!exists) {
              this.selectedRooms.push(item);
            }
          }

        })
    });
  }

  public navigateToDetailPage() {
    const currentRoomContent = this.data();

    this.searchItems.forEach((searchItem) => {
      this.messenger.send(new BreadcrumbItemToggleMessage(searchItem, CatalogConstants.CATALOG));
    });
    
    
    const isAlreadySelected = this.selectedRoomContents.some(room => room.id === currentRoomContent.id);
    if (!isAlreadySelected) {
      this.messenger.send(new BreadcrumbItemToggleMessage(currentRoomContent, CatalogConstants.CATALOG));
    }

    const currentParams = this.route.snapshot.queryParams;

    const queryParams = {
      ...currentParams,
      roomContentId: currentRoomContent.id
    }

    this.router.navigate(["/catalog/room-content", currentRoomContent.id], {
      relativeTo: this.route,
      queryParams
    });
  }


  ngOnDestroy() {
    this.messenger.unsubscribeByOwner(this);
  }
}
